// extracted by mini-css-extract-plugin
module.exports = {"managementBackground":"company-management_managementBackground__vBn3n"};